import PackageJson from "../../package.json";

export const name = PackageJson.name;
export const version = PackageJson.version;

// Production Server
let _url = "https://api.panel.carfillo.com";
if (window.location.host === "dev.panel.carfillo.com") {
  _url = "https://dev.api.panel.carfillo.com";
}
export const baseURL = _url;

// Dev Server
// export const baseURL = "http://127.0.0.1:8000";
// export const baseURL = "http://192.168.43.173:8000";
// export const baseURL = "https://api.staging.t2bon.com";
